
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M489.016 129.971V22.972H382.113V.126H512v129.845h-22.984zm-466.054.09H0V.126h129.845v22.846H22.962v107.089zm0 252.458v106.873h106.741v22.734H0V382.519h22.962zm466.054-.239H512v129.846H382.113v-22.734h106.902V382.28zM117.991 73.516c10.851 0 19.646 8.8 19.646 19.652v330.68c0 10.858-8.795 19.658-19.646 19.658-10.847 0-19.642-8.8-19.642-19.658V93.168c0-10.852 8.796-19.652 19.642-19.652zM301.59 73.516c10.854 0 19.649 8.8 19.649 19.652v330.68c0 10.858-8.795 19.658-19.649 19.658-10.847 0-19.643-8.8-19.643-19.658V93.168c0-10.852 8.796-19.652 19.643-19.652zM209.791 212.654c10.851 0 19.646 8.799 19.646 19.659v191.698c0 10.852-8.795 19.65-19.646 19.65-10.847 0-19.642-8.799-19.642-19.65V232.313c-.001-10.859 8.794-19.659 19.642-19.659zM393.505 73.658c10.854 0 19.649 8.799 19.649 19.651v191.698c0 10.859-8.795 19.65-19.649 19.65-10.847 0-19.643-8.791-19.643-19.65V93.31c0-10.852 8.796-19.652 19.643-19.652zM393.505 346.082c10.854 0 19.649 8.793 19.649 19.652v58.113c0 10.852-8.795 19.65-19.649 19.65-10.847 0-19.643-8.799-19.643-19.65v-58.113c0-10.859 8.796-19.652 19.643-19.652zM209.791 73.576c10.851 0 19.646 8.799 19.646 19.659v58.112c0 10.852-8.795 19.651-19.646 19.651-10.847 0-19.642-8.799-19.642-19.651V93.235c-.001-10.86 8.794-19.659 19.642-19.659z"}})])
          )
        }
      }
    